import { render, staticRenderFns } from "./cums-stok.vue?vue&type=template&id=4e03e859&"
import script from "./cums-stok.vue?vue&type=script&lang=js&"
export * from "./cums-stok.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports